import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionSettingsPageData } from '#src/app/pages/petitionEditV2/pageContext';

export const useDeclareVictory = () => {
	const track = useTracking();
	const settingsData = usePetitionSettingsPageData();
	const {
		petition: { id: petitionId, slug },
	} = settingsData.data;

	const handleDeclareVictory = useCallback(async () => {
		await track('petition_settings_declare_victory_button_click', { petition_id: petitionId });
	}, [petitionId, track]);

	return {
		data: {
			declareVictoryLink: `/p/${encodeURIComponent(slug)}/victory`,
		},
		actions: {
			handleDeclareVictory,
		},
	};
};
